import { useEffect, useState } from 'react'
import { sendGet } from 'hooks/use-fetch'

export interface PortalSchoolYear {
  // the start year of the ISD's current school year; upcoming is the year after. null until loaded.
  currentStartYear: number | null
  // whether caregivers can choose the upcoming school year or a specific date: from the ISD's open date, or early on a
  // provider's own link (isdServiceProviderId) when the ISD has turned on that provider's Next School Year Enrollment
  upcomingOpen: boolean
  // on that provider's link before the ISD's open date, caregivers can choose only the upcoming school year
  upcomingOnly: boolean
}

// The server works both out from the ISD's school-year settings (BusinessLogic.Domain.SchoolYear), so the years shown
// here match the school year a referral gets.
export function usePortalSchoolYear (isdId: number | string | undefined, isdServiceProviderId?: string): PortalSchoolYear {
  const [schoolYear, setSchoolYear] = useState<PortalSchoolYear>({ currentStartYear: null, upcomingOpen: false, upcomingOnly: false })
  useEffect(() => {
    const load = async (): Promise<void> => {
      const providerParam = isdServiceProviderId != null && isdServiceProviderId !== '' ? `&isdServiceProviderID=${isdServiceProviderId}` : ''
      const { response, success } = await sendGet(`/CaregiverPortal/GetISDSettings?id=${isdId ?? ''}${providerParam}`, {})
      if (success && typeof response?.currentSchoolYearStart === 'number') {
        setSchoolYear({ currentStartYear: response.currentSchoolYearStart, upcomingOpen: response.upcomingSchoolYearOpen === true, upcomingOnly: response.upcomingSchoolYearOnly === true })
      }
    }
    void load()
  }, [isdId, isdServiceProviderId])
  return schoolYear
}

// "2026-2027", or '' while the year is still loading
export const schoolYearLabel = (startYear: number | null): string => startYear == null ? '' : ` ${startYear}-${startYear + 1}`
